import { useContext } from 'react';
import { ContentfulContext } from '../ContentfulProvider';
/** @public */
function useContentful(fieldName, defaultValue) {
  const contentful = useContext(ContentfulContext);
  if (!fieldName) {
    return contentful;
  }
  const pathArray = `fields.${fieldName}`.split('.');
  return pathArray.reduce((prevPath, nextPath) => prevPath?.[nextPath] ?? defaultValue, contentful);
}
export default useContentful;